import React from 'react';
import PropTypes from 'prop-types';

export default function Ooma({ twilioNumber }) {
  return (
    <div>
      <ul>
        <li>
          Create a new extension for TrueLark
          (http://support.ooma.com/office/setting-up-extensions)
        </li>
        <li>
          Forward calls from that extension (unconditionally) to the{' '}
          {twilioNumber}
          (http://support.ooma.com/office/call-forwarding)
        </li>
        <li>
          Set-up a Ring group with “sequential ringing”
          (http://support.ooma.com/office/ring-groups):
          <ul>
            <li>
              If they already have one or more Ring Groups, then just add the
              new extension number as the last number in the relevant Ring
              Groups
            </li>
            <li>
              If they don’t have a Ring Group, then create one or more ring
              groups and set the new extension as the last in each Ring Group
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

Ooma.defaultProps = {
  twilioNumber: '',
};

Ooma.propTypes = {
  twilioNumber: PropTypes.string,
};
